/**
 * @class
 * @override
 */
import Base from 'netxcore@netx/core-auth/views/authUserLoginView';
import '../css/lib/login.less';

import MaterialCheckboxes from '@netx/core/functionality/materialCheckboxes';
import MaterialRipples from '@netx/core/functionality/materialRipples';
import MaterialTextFields from '@netx/core/functionality/materialTextFields';

class AuthUserLoginView extends Base {
	/** @override */
	constructor(opts = {}) {
		if (opts.collection) {
			// We do not care to display an internal button at this time in theme
			opts.collection = new opts.collection.constructor(
				opts.collection.filter({type: 'saml'}),
			);
			opts.events = {
				// DAM-15604
				// https://bugs.chromium.org/p/chromium/issues/detail?id=669724
				animationstart(e) {
					if (!e.originalEvent.animationName === 'onAutoFillStart') return;
					this.formChanged = true;
					this.checkForm();
				},
				...opts.events,
			};
		}
		super(opts);
	}
}

MaterialCheckboxes(AuthUserLoginView);
MaterialRipples(AuthUserLoginView);
MaterialTextFields(AuthUserLoginView);

export default AuthUserLoginView;
